import { module } from 'angular';
import templateBuilderPanelDisplay from './builder/display.html';
import templateBuilderPanelConditional from './builder/conditional.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/panel/display.html', templateBuilderPanelDisplay);
	$templateCache.put('kform/components/panel/conditional.html', templateBuilderPanelConditional);
});
